import { classNames } from "@/utils/classNames"
import { Link } from "react-router"
import { ButtonBase, ButtonBaseProps } from "../ButtonBase/ButtonBase"

export interface ButtonProps extends ButtonBaseProps {
  path?: string
  className?: string
  onClick?: () => void
  label: string
  dataTestId?: string
  elementId?: string
}

export const Button: React.FC<ButtonProps> = ({
  path,
  onClick,
  className,
  dataTestId,
  elementId,
  ...buttonBaseProps
}) => {
  if (path !== undefined) {
    return (
      <Link
        to={path}
        aria-disabled={buttonBaseProps.isDisabled}
        className={classNames(
          buttonBaseProps.isDisabled && "pointer-events-none",
          className,
        )}
        id={elementId}
      >
        <ButtonBase {...buttonBaseProps} aria-label={buttonBaseProps.label} />
      </Link>
    )
  }
  return (
    <button
      onClick={onClick}
      disabled={buttonBaseProps.isDisabled}
      aria-label={buttonBaseProps.label}
      aria-disabled={buttonBaseProps.isDisabled}
      className={classNames(buttonBaseProps.isFullWidth && "w-full", className)}
      data-testid={dataTestId}
      id={elementId}
    >
      <ButtonBase {...buttonBaseProps} />
    </button>
  )
}
